import { Element } from "@craftjs/core";
import React from "react";
// import { TbDragDrop2 } from "react-icons/tb";
import { PageContainer } from "./PageContainer";
import { PageText } from "./PageText";

import googleImage from "assets/google.png";
import CardCarousel from "components/general/CardCarousel";
import Container from "components/general/Container";
import { Box } from "components/ui";
import { Image } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";

export const TestimonialDropLocation = ({ children, ...props }: any) => {
	const childrenArray = React.Children.toArray(children?.props?.children || []);
	const hasChildren = childrenArray.length > 0;
	return (
		<CardCarousel>
			{childrenArray.map((child, key) => (
				<Box height={"$full"} key={key}>
					{child}
				</Box>
			))}
		</CardCarousel>
	);
};

export const TestimonialListTitle = ({ ...props }) => {
	let isMobile = useIsMobile();
	return (
		<Box justifyContent="center" marginBottom={isMobile ? 24 : 64} alignItems="center">
			<Box justifyContent="center">{props.children}</Box>
			<Image resizeMode="contain" source={googleImage} style={{ width: 166, height: 42 }} />
		</Box>
	);
};

export const PageTestimonials = ({ background, ...props }: { background?: string; [key: string]: any }) => {
	const isMobile = useIsMobile();
	if (isMobile) {
		return (
			<PageContainer style={{ background: background || "#fafafa", paddingVertical: 24 }}>
				<Container>
					<Box paddingHorizontal={12}>
						<Element id="listing-title" is={TestimonialListTitle} data-cy="listing-title">
							<PageText text="What our customers are saying" textAlign="center" fontSize={32} data-cy="listing-title" />
						</Element>
						<Box mb={24}>
							<Element canvas id="testimonial-drop-location" is={TestimonialDropLocation} data-cy="testimonial-drop-location"></Element>
						</Box>
						{/* <Box mb={24}>
							<CardCarousel>
								<PageTestimonialPanel />
								<PageTestimonialPanel />
								<PageTestimonialPanel />
								<PageTestimonialPanel />
								<PageTestimonialPanel />
								<PageTestimonialPanel />
							</CardCarousel>
						</Box> */}
					</Box>
				</Container>
			</PageContainer>
		);
	}
	return (
		<Box bg={background || "#fafafa"}>
			<Container>
				<PageContainer isMainContainer style={{ paddingVertical: 64, paddingHorizontal: 0 }}>
					<Box marginVertical={47} {...props}>
						<Element id="listing-title" is={TestimonialListTitle} data-cy="listing-title">
							<PageText text="What our customers are saying" fontSize={32} data-cy="listing-title" />
						</Element>
						<Box>
							<Element canvas id="testimonial-drop-location" is={TestimonialDropLocation} data-cy="testimonial-drop-location"></Element>
							{/* <CardCarousel>
							<PageTestimonialPanel />
							<PageTestimonialPanel />
							<PageTestimonialPanel />
							<PageTestimonialPanel />
							<PageTestimonialPanel />
							<PageTestimonialPanel />
						</CardCarousel> */}
						</Box>
					</Box>
				</PageContainer>
			</Container>
		</Box>
	);
};
